import React, { useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { db } from "../../../firebase";
import { addDoc, collection, doc, getDocs } from "firebase/firestore";
import { toast } from "react-hot-toast";
import { inboxList } from "../Inbox/Component/Data";

const ItemModal = ({ modalId, setIsShowItemModal, itemsList }) => {
  const [filterData, setFilterData] = useState(null);
  const [user, setUser] = useState([]);
  const [isWait, setIsWait] = useState(false);
  const [form] = Form.useForm(); // <-- get the form instance

  const fetchUserList = async () => {
    try {
      const userRef = collection(db, "allUsers");

      const querySnapshot = await getDocs(userRef);
      const allItems = querySnapshot.docs.map((doc) => doc.data());

      const newData = allItems.map((item) => ({
        value: item.uid,
        label: `${item.firstName} ${item.lastName}`,
      }));
      setUser(newData);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  function getItemListByMatchingTitleWithId(id) {
    // Find the entry with a title that matches the id
    const matchedEntry = inboxList.find((entry) =>
      entry.title.includes(String(id))
    );

    // If a matching entry is found, return its itemList
    return matchedEntry ? matchedEntry.itemList : [];
  }

  useEffect(() => {
    const filteredData = itemsList.filter((item) => item.title === modalId);

    console.log("itemsList", itemsList);
    console.log("modalId", modalId);
    console.log("filteredData", filteredData[0]);

    setFilterData(filteredData[0]);
    console.log("*************");

    // Example: Get itemList where id matches with title for id = 1
  }, [itemsList, modalId]);

  const onFinish = async (fieldsValue) => {
    setIsWait(true);
    const values = {
      ...fieldsValue,
      workFlowRunDueDate: fieldsValue["workFlowRunDueDate"]
        ? fieldsValue["workFlowRunDueDate"].format("YYYY-MM-DD HH:mm")
        : null,
    };
    const result = getItemListByMatchingTitleWithId(modalId);

    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const itemsRef = collection(itemListRef, "Assigned");

    const [date, time] = values.workFlowRunDueDate.split(" ");
    try {
      await addDoc(itemsRef, {
        workFlowRunName: modalId,
        workFlowRunTitle: values.workFlowRunName,
        workFlowRunDueTime: time,
        workFlowRunDueDate: date,
        workFlowRunAssignee: [...values.workFlowRunAssignee],
        workItemList: result,
      });
      toast.success("Task created successfully!");
      setIsWait(false);

      setIsShowItemModal(false);
      form.resetFields();
    } catch (err) {
      console.error(err);
      setIsWait(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const onOk = (value) => {
    console.log("onOk: ", value);
  };

  form.setFieldsValue({
    workFlowRunName: filterData?.title,
  });

  return (
    <div>
      <p style={{ marginBottom: "15px" }}>
        Based on {filterData?.emoji} {filterData?.title}
      </p>

      {filterData ? (
        <Form
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          form={form}
        >
          <Form.Item
            label="Workflow Run Name"
            name="workFlowRunName"
            rules={[
              {
                required: true,
                message: "Please input Workflow Run Name",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Workflow Run Assignee"
            name="workFlowRunAssignee"
            rules={[
              {
                required: true,
                message: "Please select Workflow Run Assignee",
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              style={{
                width: "100%",
              }}
              placeholder="Unassigned"
              onChange={handleChange}
              options={user}
            />
          </Form.Item>

          <Form.Item
            label="Due Date"
            name="workFlowRunDueDate"
            rules={[
              {
                required: true,
                message: "Please choose Due Date",
              },
            ]}
          >
            <DatePicker
              showTime
              onOk={onOk}
              style={{ width: "100%" }}
              placeholder="Select due date"
            />
          </Form.Item>

          <Form.Item className="form-submit-button">
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={() => {
                    setIsShowItemModal(false);
                    form.resetFields();
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" loading={isWait}>
                  {isWait ? "Please wait...":"Submit"}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      ) : null}
    </div>
  );
};

export default ItemModal;
